<body>
  <div class="grid-overlay" [ngClass]="{'empty-portal': isEmpty}">
    <app-page-header
      [logoSrc]="hasPortals ? '/assets/images/BRAND2.png' : '/assets/images/BRAND.png'"
      logoWidth="15rem">
      <app-admin-session-switcher></app-admin-session-switcher>
    </app-page-header>
    <div class="my-portals-data">
      <div class="my-portals-tabs" role="tablist">
        @for (tab of orderedTabs; track tab.id) {
          <button
            type="button"
            role="tab"
            [class.active]="activeTab === tab.id"
            [attr.aria-selected]="activeTab === tab.id"
            (click)="setActiveTab(tab.id)">
            {{ tab.labelKey | translate }}
          </button>
        }
      </div>

      <div class="my-portals-tab-panel" [class.my-portals-tab-panel--active]="activeTab === 'services'">
        <app-portal-list
          class="portal-list-slot"
          [partnerId]="partnerId"></app-portal-list>
      </div>

      <div class="my-portals-tab-panel" [class.my-portals-tab-panel--active]="activeTab === 'kpi'">
        @if (kpiTabLoaded) {
          <app-kpi-dashboard class="kpi-dashboard-slot"></app-kpi-dashboard>
        }
      </div>

      <!-- <div class="second-headboard">
      <h1>Suscripciones</h1>
      <div class="linked-icons" >
        <button >Registro inicial</button>
        <button  >Crear plan</button>
        <button class="active">Activar servicio</button>
      </div>
      <img src="../../../assets/icons/3412.png" alt="iconos de pasos">
    </div> -->
    <div class="grid">

    </div></div>

    <!-- <div class="options-buttons">
    <button class="back-btn">Atrás</button>
    <button class="continue-btn">Continuar</button>
  </div> -->
</div>
<ng-template #tabPreferenceDialog>
  <div class="tab-preference-dialog">
    <h2>{{ 'myPortals.tabPreference.title' | translate }}</h2>
    <p>{{ 'myPortals.tabPreference.description' | translate }}</p>

    <div class="tab-preference-dialog__options">
      <button
        class="tab-preference-card"
        type="button"
        [class.tab-preference-card--selected]="selectedTabPreference === 'services_first'"
        (click)="selectInitialTabPreference('services_first')">
        <img
          class="tab-preference-card__image"
          src="/assets/images/dashboard/services-dash.png"
          [alt]="'myPortals.tabPreference.servicesTitle' | translate">
        <span class="tab-preference-card__content">
          <strong>{{ 'myPortals.tabPreference.servicesTitle' | translate }}</strong>
          <span>{{ 'myPortals.tabPreference.servicesDescription' | translate }}</span>
        </span>
      </button>
      <button
        class="tab-preference-card"
        type="button"
        [class.tab-preference-card--selected]="selectedTabPreference === 'kpi_first'"
        (click)="selectInitialTabPreference('kpi_first')">
        <img
          class="tab-preference-card__image"
          src="/assets/images/dashboard/kpi-dash.png"
          [alt]="'myPortals.tabPreference.kpiTitle' | translate">
        <span class="tab-preference-card__content">
          <strong>{{ 'myPortals.tabPreference.kpiTitle' | translate }}</strong>
          <span>{{ 'myPortals.tabPreference.kpiDescription' | translate }}</span>
        </span>
      </button>
    </div>

    <div class="tab-preference-dialog__actions">
      <button type="button" class="tab-preference-dialog__close" (click)="closeTabPreferenceDialog()">
        {{ 'myPortals.tabPreference.close' | translate }}
      </button>
      <button type="button" class="tab-preference-dialog__save" (click)="saveInitialTabPreference()">
        {{ 'myPortals.tabPreference.save' | translate }}
      </button>
    </div>
  </div>
</ng-template>
</body>
